import { render, staticRenderFns } from "./AutocompleteInput.vue?vue&type=template&id=38e325c0&scoped=true&"
import script from "./AutocompleteInput.vue?vue&type=script&lang=ts&"
export * from "./AutocompleteInput.vue?vue&type=script&lang=ts&"
import style0 from "./AutocompleteInput.vue?vue&type=style&index=0&id=38e325c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e325c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
